import React, { useState, useEffect } from "react";
import { Radio, Button, Typography, Space, Form, Input, Select } from "antd";
import MinusCircleOutlined from "@ant-design/icons/MinusCircleOutlined";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import { db, timestamp } from "../../firebase";
import swal from "@sweetalert/with-react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../redux";
import { Redirect } from "react-router-dom";
import moment from "moment";

const { Option } = Select;
const { Title, Link } = Typography;
const START_OF_VOTING = moment(new Date(2022, 5, 18));
const END_OF_VOTING = moment(new Date(2022, 6, 23));

const options = [
  { label: "Apple", value: "Apple" },
  { label: "Pear", value: "Pear" },
  { label: "Orange", value: "Orange" },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};

function Voting() {
  const [value3, setValue3] = useState(null);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const onChange3 = (e) => {
    setValue3(e.target.value);
  };

  const submit = (values) => {
    console.log(values);
    const currentDate = moment(new Date(2022, 6, 9));
    if (currentDate.isBefore(START_OF_VOTING))
      return swal("Oops!", "Voting period starts on 8 June 2022.", "warning");
    if (currentDate.isAfter(END_OF_VOTING))
      return swal("Oops!", "Voting period has ended.", "warning");

    return swal({
      icon: "info",
      title: "Summary of vote",
      content: (
        <div>
          <ol>
            <li>
              Approval of the Minutes of the Annual Stockholders’ Meeting held
              on June 30, 2022
              <ul>
                <li>{values.vote1}</li>
              </ul>
            </li>
            <li>
              Election of Independent Director
              {/* {values.vote2} */}
              {typeof values.nominees === "undefined" ? (
                <ul>
                  <li>{(values.nominees = [values.vote2])}</li>
                </ul>
              ) : (
                <ol type="A">
                  {values.nominees.map((nominee) => (
                    <li>{nominee}</li>
                  ))}
                </ol>
              )}
            </li>
            <li>
              Approval of Amendment of Article Seventh of the Articles of Incorporation to increase Authorized Capital Stock for Preferred Shares
              <ul>
                <li>{values.vote3}</li>
              </ul>
            </li>
            <li>
            Approval of Offer, Sale, and Listing of Additional Preferred Shares
              <ul>
                <li>{values.vote4}</li>
              </ul>
            </li>
            {/* <li>
              Approval of Amendments to the Articles of Incorporation to
              expressly remove the development of real estate in the purposes of
              the Company, given that it does not engage in the business of real
              estate development
              <ul>
                <li>{values.vote5}</li>
              </ul>
            </li>
            <li>
              Approval of Amendments to the By-Laws to align with the provisions
              of the Revised Corporation Code and SEC Memorandum Circular No.
              06, Series of 2020
              <ul>
                <li>{values.vote6}</li>
              </ul>
            </li>
            <li>
              Ratification of all acts of Management and the Board of Directors
              <ul>
                <li>{values.vote7}</li>
              </ul>
            </li> */}
          </ol>
        </div>
      ),
      buttons: {
        cancel: "Back",
        confirm: {
          text: "Submit",
          value: "submit",
        },
      },
    }).then((val) => {
      if (val === "submit") {
        const vote = {
          vote1: values.vote1,
          vote2: values.vote2,
          vote3: values.vote3,
          vote4: values.vote4,
          // vote5: values.vote5,
          // vote7: values.vote7,
          nominees: values.nominees,
          timestamp: timestamp.fromDate(new Date()),
          fullname: auth.fullname,
          noOfShares: auth.noOfShares ?? null,
        };
        console.log(vote);
        const payload = { ...auth };
        payload.hasVoted = true;

        dispatch(actions.signedIn(payload));
        db.collection("users").doc(auth.email).update({ hasVoted: true });
        db.collection("votes").add(vote);

        swal(
          "Thank you for casting your vote.",
          "The total votes casted, as well as the number of shares represented by the same, shall be announced during the 2022 Special Stockholders’ Meeting of Megawide Construction Corporation on 30 June 2022.",
          "success"
        );
      }
    });
  };

  return (
    <div>
      {auth.isLoggedIn ? (
        <div style={{ maxWidth: "1000px", margin: "auto" }}>
          {auth.hasVoted ? (
            <>
              <Title level={2}>
                Thank you for casting your vote. The total votes casted, as well
                as the number of shares represented by the same, shall be
                announced during the 2022 Special Stockholders’ Meeting of
                Megawide Construction Corporation on 20 December 2022.
              </Title>
              <Title level={2}>
                You may attend Megawide Construction Corporation’s Special
                Stockholders’ Meeting on 20 December 2022 at 1:00 P.M., through the
                following link:{" "}
                <Link
                  href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_NmMyNWRlOTAtZmYzNC00ODlmLTgzOGUtODA1MTdmOTY5N2E1%40thread.v2/0?context=%7B%22Tid%22%3A%22036b84b7-26b8-441d-87c1-f3590d3f2ed1%22%2C%22Oid%22%3A%22adac7404-bd6e-427b-bf7b-722639c45b6f%22%2C%22IsBroadcastMeeting%22%3Atrue%2C%22role%22%3A%22a%22%7D&btype=a&role=a"
                  target="_blank"
                  underline
                >
                  Megawide 2022 SSM
                </Link>
              </Title>
            </>
          ) : (
            <Form onFinish={submit}>
              <ol type="1">
                <li className="tabbed spacing">
                  Approval of the Minutes of the Annual Stockholders’ Meeting
                  held on June 30, 2022
                  <br />
                  <Form.Item
                    name="vote1"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li>
                <li className="tabbed spacing">
                  Election of Independed Director
                  <br />
                  <Form.Item
                    name="vote2"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group onChange={onChange3} value={value3}>
                      <Space direction="vertical">
                        <Radio value="Vote for nominee">
                          Vote for nominee Atty. Lilia B. de Lima (Independent
                          Director)
                        </Radio>
                        <Radio value="Withhold authority for nominee">
                          Withhold authority for nominee Atty. Lilia B. de Lima
                          (Independent Director)
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  {value3 ===
                  "Withhold authority to vote for the nominees listed below:" ? (
                    <Form.Item
                      label="Nominee/s"
                      name="nominees"
                      rules={[
                        {
                          validator: async (_, nominees) => {
                            if (!nominees || nominees.length < 1) {
                              return Promise.reject(
                                new Error("Select at least 1 nominee")
                              );
                            }
                          },
                        },
                      ]}
                    >
                      <Select style={{ width: "25%" }} mode="multiple">
                        <Option value="Edgar B. Saavedra">
                          Edgar B. Saavedra
                        </Option>
                        <Option value="Oliver Y. Tan">Oliver Y. Tan</Option>
                        <Option value="Manuel Louie B. Ferrer">
                          Manuel Louie B. Ferrer
                        </Option>
                        <Option value="Ramon H. Diaz">Ramon H. Diaz</Option>
                        <Option value="Hilario G. Davide Jr.">
                          Hilario G. Davide Jr.
                        </Option>
                        <Option value="Celso P. Vivas">Celso P. Vivas</Option>
                      </Select>
                    </Form.Item>
                  ) : (
                    <></>
                  )}
                </li>
                <li className="tabbed spacing">
                  Approval of Amendment of Article Seventh of the Articles of
                  Incorporation to increase Authorized Capital Stock for
                  Preferred Shares
                  <br />
                  <Form.Item
                    name="vote3"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li>
                <li className="tabbed spacing">
                  Approval of Offer, Sale, and Listing of Additional Preferred
                  Shares
                  <br />
                  <Form.Item
                    name="vote4"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li>
                {/* <li className="tabbed spacing">
                  Approval of Amendments to the Articles of Incorporation to
                  expressly remove the development of real estate in the
                  purposes of the Company, given that it does not engage in the
                  business of real estate development
                  <br />
                  <Form.Item
                    name="vote5"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li>
                <li className="tabbed spacing">
                  Approval of Amendments to the By-Laws to align with the
                  provisions of the Revised Corporation Code and SEC Memorandum
                  Circular No. 06, Series of 2020
                  <br />
                  <Form.Item
                    name="vote6"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li>
                <li className="tabbed spacing">
                  Ratification of all acts of Management and the Board of
                  Directors
                  <br />
                  <Form.Item
                    name="vote7"
                    rules={[
                      { required: true, message: "Please choose your vote" },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                      <Radio value="Abstain">Abstain</Radio>
                    </Radio.Group>
                  </Form.Item>
                </li> */}
              </ol>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      ) : (
        <Redirect to="/" />
      )}
    </div>
  );
}

export default Voting;
